"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(() => ({
  margin: '125px auto',
  width: '100%',
  maxWidth: '1000px',
  textAlign: 'center',
  padding: '0 0 10px',
  '& > *': {
    padding: '0 8%',
    marginBottom: '20px'
  }
}));
